import { QuestionItemsInnerWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/items-inner-wrapper";
import { EditGuideTooltip } from "@/components/features/items/edit/_shared/ui/components/system/tooltip/edit-guide-tooltip";

import { Label } from "@/components/ui/label/label";

export interface QuestionProps {
	required?: boolean;
	title: string;

	inputChildren: React.ReactNode;

	/** 見出し（title）の直下に置く補足（入力欄の `ml-4` より外側） */
	belowTitleChildren?: React.ReactNode;

	guide?: string;
}

export const QuestionForMain = ({
	title, //
	required = false,
	inputChildren,
	belowTitleChildren,
	guide,
}: QuestionProps) => {
	return (
		// タイトルと入力項目が縦並び
		<div className="flex flex-col gap-2">
			<div className="flex flex-col gap-4">
				<div className="flex flex-col gap-2">
					<div className="flex items-start">
						<div className="relative flex flex-wrap items-center gap-x-2 gap-y-1">
							<div className="flex items-center gap-x-2">
								{/* 設定項目のタイトル */}
								<h5 className="text-base font-semibold">{title}</h5>
								{required && <Label text={"必須"} size={"sm"} variant="required" />}
							</div>
							{/* 設定を補助するテキスト */}
							<EditGuideTooltip guide={guide} />
						</div>
					</div>
					{belowTitleChildren}
				</div>
				{/* <div className="ml-4 mt-4"> */}
				<QuestionItemsInnerWrapper>{inputChildren}</QuestionItemsInnerWrapper>
				{/* </div> */}
			</div>
		</div>

		// タイトルと入力項目が横並び
		// <div className="flex flex-col gap-2">
		// 	<div>{required && <Label text={"必須"} size={"sm"} />}</div>

		// 	<div className="flex flex-col gap-4 lg:grid lg:grid-cols-12">
		// 		<div className="col-span-4 flex items-start">
		// 			<div className="flex flex-wrap items-center gap-x-2 gap-y-1">
		// 				<h5>{label}</h5>
		// 				<EditGuideTooltip guide={guide} />
		// 			</div>
		// 		</div>
		// 		<div className="col-span-8">{inputChildren}</div>
		// 	</div>
		// </div>
	);
};

QuestionForMain.displayName = "QuestionForMain";
